<template>
  <div class="school-courses-list-view">
    <!-- 目录分类筛选条 -->
    <div class="category-filter-bar">
      <span class="filter-label">目录:</span>
      <div class="filter-options">
        <span
          class="filter-option-item"
          :class="{ active: activeClassifyId === '' }"
          @click="selectClassify('')"
        >
          全部
        </span>
        <span
          class="filter-option-item"
          v-for="item in classifyList"
          :key="item.id"
          :class="{ active: activeClassifyId === item.id }"
          @click="selectClassify(item.id)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>

    <!-- 列表展现区 -->
    <div class="school-dashboard" style="margin-top: 10px">
      <div class="dashboard-section">
        <!-- 加载动画 -->
        <SchoolLoading :visible="loading" />

        <div class="packages-grid" v-if="list.length">
          <div
            class="package-card"
            v-for="item in list"
            :key="item.id"
            @click="toPackageDetails(item)"
          >
            <div class="package-cover-wrap">
              <img :src="item.cover" class="package-cover hoverTransform" />
            </div>
            <div class="package-card-content">
              <div class="package-title-wrap">
                <div class="package-title textOverflowOne">
                  {{ item.title }}
                </div>
                <div class="package-subtitle textOverflowOne">
                  {{ item.subtitle }}
                </div>
              </div>
              <div class="package-footer">
                <div class="package-subs">
                  <i class="el-icon-user"></i>
                  <span>{{ item.subscribeCount || 0 }}人订阅</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <None v-else />

        <!-- 分页导航 -->
        <div class="pagination-container" v-if="total > 0">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { coursePackageList, coursePackageClassifyList } from "@/api/lx";
import SchoolLoading from "./SchoolLoading.vue";

export default {
  name: "StudySchedule",
  components: {
    SchoolLoading,
  },
  data() {
    return {
      classifyList: [], // 课程包分类列表
      activeClassifyId: "", // 选中的分类ID
      list: [], // 课程包分页数据
      currentPage: 1,
      pageSize: 8, // 每页 8 条
      total: 0,
      loading: false,
    };
  },
  created() {
    this.getClassifyList();
    this.loadPackages();
  },
  methods: {
    /**
     * 获取课程包全分类
     */
    getClassifyList() {
      coursePackageClassifyList({ state: 1 })
        .then((res) => {
          this.classifyList = res.data || [];
        })
        .catch((err) => {
          console.error("加载课程包分类出错:", err);
        });
    },
    /**
     * 加载课程包数据
     */
    loadPackages() {
      this.loading = true;
      const startTime = Date.now();
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };
      if (this.activeClassifyId) {
        params.classifyId = this.activeClassifyId;
      }
      coursePackageList(params)
        .then((res) => {
          const data = res.data || {};
          this.list = data.records || [];
          this.total = data.total || 0;
        })
        .catch((err) => {
          console.error("加载课程包列表数据出错:", err);
        })
        .finally(() => {
          // 确保最少有 500 毫秒的加载效果，防止网络过快时闪烁
          const duration = Date.now() - startTime;
          const delay = Math.max(0, 500 - duration);
          setTimeout(() => {
            this.loading = false;
          }, delay);
        });
    },
    /**
     * 选择分类
     */
    selectClassify(id) {
      if (this.activeClassifyId === id) return;
      this.activeClassifyId = id;
      this.currentPage = 1;
      this.list = [];
      this.total = 0;
      this.loadPackages();
    },
    /**
     * 分页改变回调
     */
    handlePageChange(page) {
      this.currentPage = page;
      this.loadPackages();
      // 滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    /**
     * 点击课程包跳转详情，向上派发事件
     * @param {Object} item - 课程包元数据
     * @returns {void}
     */
    toPackageDetails(item) {
      this.$emit("to-package-details", item);
    },
  },
};
</script>

<style lang="less" scoped>
/* Study schedule view nested style blocks */
.school-courses-list-view {
  width: 100%;
  min-height: 70vh;
  padding-bottom: 60px;
  box-sizing: border-box;
}

/* 目录筛选条 */
.category-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 24px;
  box-shadow: 0px 4px 16px rgba(0, 22, 26, 0.03);
  margin-bottom: 24px;
  box-sizing: border-box;
}

.filter-label {
  font-size: 14px;
  font-weight: 700;
  color: #7b8e99;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-option-item {
  padding: 6px 16px;
  font-size: 13px;
  color: #3b4a47;
  cursor: pointer;
  background: transparent;
  transition: all 0.25s ease;
  user-select: none;
  font-weight: 500;

  &:hover {
    color: #00d8c3;
    background: rgba(0, 216, 195, 0.05);
  }

  &.active {
    background: rgba(0, 216, 195, 0.1);
    color: rgb(0, 216, 195);
    font-weight: 700;
  }
}

.school-dashboard {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.dashboard-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Packages grid layout and items */
.packages-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.package-card {
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.3);
  overflow: hidden;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 12px 24px rgba(0, 22, 26, 0.08);
    .hoverTransform {
      transform: scale(1.05);
    }
  }
}

.package-cover-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.package-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.package-card-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.package-title-wrap {
  min-height: 52px;
}

.package-title {
  color: #333333;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.package-subtitle {
  color: #8c9694;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.package-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(186, 202, 198, 0.15);
  padding-top: 12px;
}

.package-subs {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b7a77;
  font-size: 13px;
  font-weight: 500;
  i {
    font-size: 14px;
  }
}

.package-action {
  color: #00d8c3;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #00c4b0;
  }
}

/* Pagination */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
</style>
